(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serenity-fit-match"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('serenity-fit-match')) {
    customElements.define('serenity-fit-match', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const button = this.querySelector('[data-book]');
        button.hidden = false;
        button.addEventListener('click', () => {
          const hero = document.querySelector('serenity-hero');
          const message = this.querySelector('[data-message]');
          if (!hero || typeof hero.openBooking !== 'function') {
            message.hidden = false;
            return;
          }
          message.hidden = true;
          button.focus({ preventScroll: true });
          document.dispatchEvent(new CustomEvent('serenity:open-booking', {
            detail: { format: '' }
          }));
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serenity-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('serenity-hero')) {
    customElements.define('serenity-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.continueButton = this.querySelector('[data-sh-continue]');
        this.status = this.querySelector('[data-sh-status]');
        this.trigger = null;

        this.querySelector('[data-sh-open]').addEventListener('click', (event) => {
          this.openBooking('', event.currentTarget);
        }, options);

        this.querySelector('[data-sh-close]').addEventListener('click', () => {
          this.dialog.close();
        }, options);

        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (
            event.clientX < rect.left || event.clientX > rect.right ||
            event.clientY < rect.top || event.clientY > rect.bottom
          ) {
            this.dialog.close();
          }
        }, options);

        this.dialog.addEventListener('close', () => {
          if (this.trigger && this.trigger.isConnected) {
            this.trigger.focus();
          }
        }, options);

        this.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.addEventListener('change', () => this.updateChoice(), options);
        });

        this.continueButton.addEventListener('click', () => {
          const selected = this.querySelector('input[type="radio"]:checked');
          if (!selected || !selected.dataset.url) return;
          const url = new URL(selected.dataset.url, window.location.origin);
          if (url.protocol === 'https:') {
            window.location.assign(url.href);
          }
        }, options);

        document.addEventListener('serenity:open-booking', (event) => {
          const detail = event.detail || {};
          this.openBooking(detail.format || '', document.activeElement);
        }, options);
      }

      openBooking(format, trigger) {
        this.trigger = trigger;

        this.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = input.value === format;
        });

        this.updateChoice();
        if (!this.dialog.open) this.dialog.showModal();
      }

      updateChoice() {
        const selected = this.querySelector('input[type="radio"]:checked');
        let valid = false;

        if (selected && selected.dataset.url) {
          try {
            valid = new URL(
              selected.dataset.url,
              window.location.origin
            ).protocol === 'https:';
          } catch (error) {
            valid = false;
          }
        }

        this.continueButton.disabled = !valid;
        this.status.textContent = selected && !valid
          ? this.status.dataset.unavailable
          : '';
      }

      disconnectedCallback() {
        if (this.dialog && this.dialog.open) this.dialog.close();
        if (this.controller) this.controller.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serenity-match-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('serenity-match-finder')) {
    customElements.define('serenity-match-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.steps = Array.from(this.querySelectorAll('[data-question]'));
        this.index = 0;
        this.answers = {};
        this.direction = '';
        const options = { signal: this.controller.signal };
        if (this.steps.length !== 5) return;
        this.start(false);
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-restart')) this.restart();
          if (button.hasAttribute('data-back') && this.index > 0) { this.index--; this.showStep(); }
          if (button.hasAttribute('data-next') && this.answers[this.steps[this.index].dataset.question]) {
            if (this.index < this.steps.length - 1) { this.index++; this.showStep(); }
            else this.showResult();
          }
          if (button.hasAttribute('data-book')) this.book();
        }, options);
        this.addEventListener('change', (event) => {
          if (!event.target.matches('input[type="radio"]')) return;
          const step = event.target.closest('[data-question]');
          this.answers[step.dataset.question] = event.target.value;
          this.querySelector('[data-next]').disabled = false;
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
      focusOn(element) {
        element.focus({ preventScroll: true });
        element.scrollIntoView({ block: 'nearest', behavior: 'auto' });
      }
      start(moveFocus = true) {
        this.querySelector('[data-result]').hidden = true;
        this.querySelector('[data-quiz]').hidden = false;
        this.showStep(moveFocus);
      }
      restart() {
        this.answers = {};
        this.index = 0;
        this.direction = '';
        this.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = false; });
        this.querySelector('[data-booking-message]').hidden = true;
        this.start();
      }
      showStep(moveFocus = true) {
        this.steps.forEach((step, index) => { step.hidden = index !== this.index; });
        this.querySelector('[data-number]').textContent = this.index + 1;
        this.querySelector('progress').value = this.index + 1;
        this.querySelector('[data-back]').disabled = this.index === 0;
        this.querySelector('[data-quiz] [data-restart]').hidden = this.index === 0;
        this.querySelector('[data-percent]').textContent = ((this.index + 1) * 20) + '%';
        const last = this.index === this.steps.length - 1;
        this.querySelector('[data-next-label]').hidden = last;
        this.querySelector('[data-finish-label]').hidden = !last;
        this.querySelector('[data-next]').disabled = !this.answers[this.steps[this.index].dataset.question];
        if (moveFocus) this.focusOn(this.steps[this.index].querySelector('legend'));
      }
      showResult() {
        const coverage = this.answers.coverage;
        this.direction = coverage === 'full' ? 'wig' : ['top', 'volume'].includes(coverage) ? 'topper' : 'both';
        this.querySelectorAll('[data-direction]').forEach(item => { item.hidden = item.dataset.direction !== this.direction; });
        this.querySelectorAll('[data-priority]').forEach(item => { item.hidden = item.dataset.priority !== this.answers.priority; });
        const summary = this.querySelector('[data-summary]');
        summary.replaceChildren();
        this.steps.forEach(step => {
          const checked = step.querySelector('input:checked');
          const term = document.createElement('dt');
          const description = document.createElement('dd');
          term.textContent = step.querySelector('legend').textContent;
          description.textContent = checked.closest('label').querySelector('span').textContent;
          summary.append(term, description);
        });
        this.querySelector('[data-quiz]').hidden = true;
        this.querySelector('[data-result]').hidden = false;
        this.focusOn(this.querySelector('[data-result] h3'));
      }
      book() {
        const hero = document.querySelector('serenity-hero');
        if (!hero || typeof hero.openBooking !== 'function') {
          this.querySelector('[data-booking-message]').hidden = false;
          return;
        }
        this.querySelector('[data-book]').focus({ preventScroll: true });
        document.dispatchEvent(new CustomEvent('serenity:open-booking', {
          detail: {
            format: this.answers.format === 'unsure' ? '' : this.answers.format,
            direction: this.direction
          }
        }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
